module.exports = __webpack_public_path__ + "static/img/6.9caeb85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/6.png
// module id = ygnX
// module chunks = 0